import type {
  DefinitionSelection,
  PnlReportDefinition,
  ReportDefinitionDraft,
  ReportParameter,
  ReportParameterOption,
  SavedDefinedReport
} from 'src/components/star-grid/reportDefinition.types';
import type { PnlHierarchyMember } from 'src/components/star-grid/starGridTypes';

export const parameterOptions = (members: readonly PnlHierarchyMember[], parent: readonly string[] = []): ReportParameterOption[] =>
  members.flatMap((member) => [
    { value: member.id, label: member.label, description: parent.join(' / ') },
    ...parameterOptions(member.children, [...parent, member.label])
  ]);
export const uniqueParameterOptions = (options: readonly ReportParameterOption[]): ReportParameterOption[] => [
  ...new Map(options.map((option) => [option.value, option])).values()
];
export const selectedParameterOptions = (
  parameter: ReportParameter,
  values: readonly string[],
  options: readonly ReportParameterOption[]
): ReportParameterOption[] => values.map((value) => options.find((option) => option.value === value) ?? { value, label: value });
